// contact service
export default {
    install: (Vue) => {
      //private
      const route = process.env.VUE_APP_API_BASE_URL + '/api/contacts';
  
      //public
      Vue.$contactService = {
        create(params) {
          return Vue.axios.post(route, {
            params: params
          });
        }
      };
    }
  };
//   //example of use
//   var grants = await Vue.$grantService.find({
//     name: 'test'
//   });